import { alpha, styled } from '@mui/material/styles'
import { Box, Typography } from '@mui/material'

export const SectionCard = styled(Box)(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: 8,
  overflow: 'hidden',
  marginBottom: theme.spacing(1)
}))

export const BannerBox = styled(Box)(({ theme }) => ({
  borderLeft: `4px solid ${theme.palette.primary.main}`,
  backgroundColor: alpha(theme.palette.primary.main, 0.08),
  padding: theme.spacing(0.75, 1.5)
}))

export const ContentBox = styled(Box)(({ theme }) => ({
  padding: theme.spacing(1.5),
  backgroundColor: theme.palette.background.paper
}))

export const DescriptionText = styled(Typography)(() => ({
  fontWeight: 700,
  color: 'rgba(0, 0, 0, 0.7)'
}))
